import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M19 11L12 22L5 11L11.25 11L11.25 2L12.75 2L12.75 11L19 11Z" fill="black"/>
    </svg>
)
